import axiosIns from '@/plugins/axios'

export default {
  getRebates() {
    return axiosIns.get('/admin/rebates')
  },
}
